module.exports = __webpack_public_path__ + "img/fromages.1a9d1426.png";